// extracted by mini-css-extract-plugin
export default {"masonry":"components-Editorials-masonry__masonry--NwJkO","column":"components-Editorials-masonry__column--pVhkk"};